import { atom } from "jotai";
import { NodeProps } from "@xyflow/react";
import { nodeAtomFamily } from "./nodeAtomFamily";

export const addSuggestedTargetNodeSetter = atom(
  null,
  async (get, set, sourceNodeId: NodeProps["id"]) => {
    const sourceNode = get(nodeAtomFamily(sourceNodeId));
    if (!sourceNode) {
      return;
    }

    // Use 'label' only if it exists on data, otherwise fallback to type
    // Workaround for weird typing on NodeData

    const workflowStep =
      "label" in sourceNode.data && sourceNode.data.label
        ? sourceNode.data.label
        : sourceNode.type;

    try {
      // Instead of creating a suggested node, send a message to Copilot
      window.postMessage(
        {
          type: "COPILOT_USER_MESSAGE",
          payload: {
            message: `Based on my current workflow step "${workflowStep}", suggest what to add next to my system`,
            source: "suggest-node-action",
          },
        },
        "*",
      );
    } catch (error) {
      console.error("Failed to send message to copilot:", error);
    }
  },
);

addSuggestedTargetNodeSetter.debugLabel = "addSuggestedTargetNodeSetter";
